module.exports = __webpack_public_path__ + "img/P150T_weapon_31.dc68984f.png";